var map = {
	"./agricultural/agricultural_beige.svg": 88961,
	"./agricultural/agricultural_black.svg": 97844,
	"./agricultural/agricultural_blue.svg": 33047,
	"./agricultural/agricultural_brown.svg": 80781,
	"./agricultural/agricultural_green.svg": 93964,
	"./agricultural/agricultural_grey.svg": 96786,
	"./agricultural/agricultural_orange.svg": 9465,
	"./agricultural/agricultural_red.svg": 3820,
	"./agricultural/agricultural_violet.svg": 7902,
	"./agricultural/agricultural_yellow.svg": 86739,
	"./freight/freight_beige.svg": 19229,
	"./freight/freight_black.svg": 87440,
	"./freight/freight_blue.svg": 63067,
	"./freight/freight_brown.svg": 43177,
	"./freight/freight_green.svg": 18224,
	"./freight/freight_grey.svg": 9150,
	"./freight/freight_orange.svg": 69845,
	"./freight/freight_red.svg": 88016,
	"./freight/freight_violet.svg": 94418,
	"./freight/freight_yellow.svg": 88631,
	"./passenger/passenger_beige.svg": 92953,
	"./passenger/passenger_black.svg": 59324,
	"./passenger/passenger_blue.svg": 73983,
	"./passenger/passenger_brown.svg": 26869,
	"./passenger/passenger_green.svg": 2500,
	"./passenger/passenger_grey.svg": 98938,
	"./passenger/passenger_orange.svg": 94801,
	"./passenger/passenger_red.svg": 56788,
	"./passenger/passenger_violet.svg": 9766,
	"./passenger/passenger_white.svg": 38202,
	"./passenger/passenger_yellow.svg": 82187,
	"./personal/personal_beige.svg": 51011,
	"./personal/personal_black.svg": 39818,
	"./personal/personal_blue.svg": 241,
	"./personal/personal_brown.svg": 20739,
	"./personal/personal_green.svg": 22602,
	"./personal/personal_grey.svg": 57024,
	"./personal/personal_orange.svg": 99767,
	"./personal/personal_red.svg": 53146,
	"./personal/personal_violet.svg": 24484,
	"./personal/personal_white.svg": 53168,
	"./personal/personal_yellow.svg": 39185,
	"./taxi/taxi_beige.svg": 69995,
	"./taxi/taxi_black.svg": 32354,
	"./taxi/taxi_blue.svg": 14185,
	"./taxi/taxi_brown.svg": 21787,
	"./taxi/taxi_green.svg": 56722,
	"./taxi/taxi_grey.svg": 94040,
	"./taxi/taxi_orange.svg": 39551,
	"./taxi/taxi_red.svg": 45874,
	"./taxi/taxi_violet.svg": 77916,
	"./taxi/taxi_white.svg": 95784,
	"./taxi/taxi_yellow.svg": 5337
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40957;